export enum SideViewSectionEnum {
  CAPACITY = "capacity",
  BUDGETARY = "budgetary",
}
